/**
 * Session Cookie Generator for Athena - Blocks scraper bots
 * @version 1.0.1
 */

var COOKIE_NAME = 'athena_js_session';
var COOKIE_MAX_AGE_SECONDS = 86400;
var COOKIE_PATH = '/';
var COOKIE_SAME_SITE = 'Strict';

function getDateString(date) {
  if (!date) date = new Date();
  return date.toISOString().slice(0, 10).replace(/-/g, '');
}

function djb2Hash(str) {
  var hash = 5381;
  for (var i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) ^ str.charCodeAt(i);
  }
  var result = (hash >>> 0).toString(16);
  while (result.length < 8) result = '0' + result;
  return result;
}

function collectFingerprint() {
  var data = [
    navigator.userAgent,
    screen.width.toString(),
    screen.height.toString(),
    new Date().getTimezoneOffset().toString(),
    navigator.language,
    screen.colorDepth.toString(),
    (navigator.hardwareConcurrency || 1).toString(),
    navigator.platform || '',
    typeof performance !== 'undefined' ? Math.floor(performance.now()).toString() : '0',
    getCanvasFingerprint()
  ];
  return data.join('|');
}

function getCanvasFingerprint() {
  try {
    var c = document.createElement('canvas');
    var ctx = c.getContext('2d');
    if (!ctx) return 'no-canvas';
    c.width = 200;
    c.height = 50;
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText('Athena OHDSI', 2, 15);
    return djb2Hash(c.toDataURL());
  } catch (e) {
    return 'err';
  }
}

function generateToken() {
  var d = getDateString(null);
  var entropy = [d, 'athena-js-2026', collectFingerprint(), Math.random().toString(36).substring(2)].join('::');
  return d + '_' + djb2Hash(entropy);
}

function getSessionCookie() {
  var match = document.cookie.match(new RegExp(COOKIE_NAME + '=([^;]+)'));
  return match ? match[1] : null;
}

function isValidCookie(v) {
  if (!v) return false;
  var p = v.split('_');
  if (p.length !== 2) return false;
  var today = getDateString(null);
  var yesterday = getDateString(new Date(Date.now() - 86400000));
  return p[0] === today || p[0] === yesterday;
}

function setSessionCookie(token) {
  var exp = new Date(Date.now() + COOKIE_MAX_AGE_SECONDS * 1000);
  var parts = [
    COOKIE_NAME + '=' + token,
    'expires=' + exp.toUTCString(),
    'path=' + COOKIE_PATH,
    'SameSite=' + COOKIE_SAME_SITE
  ];
  if (window.location.protocol === 'https:') {
    parts.push('Secure');
  }
  document.cookie = parts.join('; ');
}

function initSessionCookie() {
  try {
    if (!isValidCookie(getSessionCookie())) {
      setSessionCookie(generateToken());
    }
  } catch (e) {
    if (typeof console !== 'undefined' && console.error) {
      console.error('[Athena] Session cookie error:', e);
    }
  }
}

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  // Set cookie IMMEDIATELY - don't wait for DOMContentLoaded
  initSessionCookie();
  
  // Refresh hourly
  setInterval(function() {
    if (!isValidCookie(getSessionCookie())) {
      initSessionCookie();
    }
  }, 3600000);
}

